export type ProductCaptureGroupType = `${ProductCaptureGroupsEnum}`;

export enum ProductCaptureGroupsEnum {
  legalForm = 'legalForm',
  payoff = 'payoff',
  sales = 'sales',
  summary = 'summary',
  agents = 'agents',
  eventSchedules = 'eventSchedules',
  pricing = 'pricing',
  creditProvision = 'creditProvision',
  notesAndTasks = 'notesAndTasks',
  multiIssuance = 'multiIssuance',
  targetMarkets = 'targetMarkets',
  workflows = 'workflows'
}

export enum ScheduleEnum {
  scheduleType = 'scheduleType',
  scheduleStrategy = 'scheduleStrategy',
  refRateFixingLag = 'refRateFixingLag',
  obsScheduleLag = 'obsScheduleLag',
  pmtScheduleLag = 'pmtScheduleLag',
  pmtLagBaseType = 'pmtLagBaseType',
  accrualScheduleLagBase = 'accrualScheduleLagBase',
  barrier = 'barrier',
  barrierStepSize = 'barrierStepSize',
  type = 'type',
  deferredPeriods = 'defferedPeriods',
  barrierType = 'barrierType',
  frequency = 'frequency',
  schedule = 'schedule',
  tenor = 'tenor',
  callNoticeLag = 'callNoticeLag',
  callNoticeLagBaseType = 'callNoticeLagBaseType',
  lastPeriodCallable = 'lastPeriodCallable',
  accrualRollConvention = 'accrualRollConvention',
  dayCount = 'dayCount',
  obsRollConfig = 'obsRollConfig',
  pmtRollConfig = 'pmtRollConfig',
  accrualRollConfig = 'accrualRollConfig',
  adjustmentRollConfig = 'adjustmentRollConfig',
  exerciseRollConfig = 'exerciseRollConfig',
  lowerLevel = 'lowerLevel',
  lowerBarrierStepSize = 'lowerBarrierStepSize',
  upperLevel = 'upperLevel',
  upperBarrierStepSize = 'upperBarrierStepSize',
  fixedPeriods = 'fixedPeriods',
}

export enum CallabilityEnum {
  callEventType = 'callEventType',
  frequency = 'frequency',
  deferredPeriods = 'deferredPeriods',
  lastPeriodCallable = 'lastPeriodCallable',
  schedule = 'schedule',
  amountType = 'amountType',
  amount = 'amount',
  amountStepSize = 'amountStepSize',
  barrier = 'barrier',
}

export enum CallabilityBarrierEnum {
  level = 'level',
  obsFrequency = 'obsFrequency',
  stepSize = 'stepSize',
  touchAndBreak = 'touchAndBreak',
  type = 'type',
}

export enum InvestorExerciseEnum {
  frequency = 'frequency',
  scheduleCalendar = 'scheduleCalendar',
}

export enum ParticipationEnum {
  downSidetype = 'downSidetype',
  strike = 'strike',
  leverage = 'leverage',
  capitalBase = 'capitalBase',
  obvsFrequency = 'obvsFrequency',
  touchBreak = 'touchBreak',
  schedule = 'schedule',

  upside = 'upside',
  downside = 'downside',
  base = 'base',
  barrier = 'barrier',
}

export enum ParticipationUpsideEnum {
  type = 'type',
  callStrike = 'callStrike',
  callParticipation = 'callParticipation',
  callSpreadStrike = 'callSpreadStrike',
  putStrike = 'putStrike',
  putParticipation = 'putParticipation',
  putSpreadStrike = 'putSpreadStrike',
  digitalAmount = 'digitalAmount',
  digitalStrike = 'digitalStrike',
  barrier = 'barrier',
  rebateAmount = 'rebateAmount',
  earlyTermination = 'earlyTermination',
  rebateDate = 'rebateDate',
  rebateSettlementLag = 'rebateSettlementLag',
  minimumReturn = 'minimumReturn',
  strikeAdjustmentRateBasis = 'strikeAdjustmentRateBasis',
  strikeAdjustmentFixedRate = 'strikeAdjustmentFixedRate',
  strikeAdjustmentFloatingReferenceRate = 'strikeAdjustmentFloatingReferenceRate',
  strikeAdjustmentFactor = 'strikeAdjustmentFactor',
  strikeAdjustmentDayCountBasis = 'strikeAdjustmentDayCountBasis',
  adjustmentDatesScheduleCalendar = 'adjustmentDatesScheduleCalendar',
  adjustmentDatesScheduleFrequency = 'adjustmentDatesScheduleFrequency',
}

export enum ParticipationUpsideBarrierEnum {
  level = 'level',
  obsFrequency = 'obsFrequency',
  touchAndBreak = 'touchAndBreak',
  lowerLevel = 'lowerLevel',
  upperLevel = 'upperLevel',
  direction = 'direction',
  type = 'type',
  initialBarrierAdjustmentFactor = 'initialBarrierAdjustmentFactor',
  minBarrierAdjustmentFactor = 'minBarrierAdjustmentFactor',
  maxBarrierAdjustmentFactor = 'maxBarrierAdjustmentFactor',
  barrierAdjustmentRoundingRule = 'barrierAdjustmentRoundingRule',
}

export enum ParticipationDownsideEnum {
  downsideType = 'downsideType',
  strike = 'strike',
  leverage = 'leverage',
  leverageOptions = 'leverageOptions',
  floorStrike = 'floorStrike',
  barrier = 'barrier',
  schedule = 'schedule',
}

export enum ParticipationDownsideBarrierEnum {
  level = 'level',
  obsFrequency = 'obsFrequency',
  touchAndBreak = 'touchAndBreak',
}

export enum ParticipationBaseEnum {
  type = 'type',
  leverage = 'leverage',
  bonusStrike = 'bonusStrike',
  bonusAmount = 'bonusAmount',
  capped = 'capped',
  globalCap = 'globalCap',
  globalFloor = 'globalFloor',
  barrier = 'barrier',
  bonusKnockOut = 'bonusKnockOut',
  strike = 'strike',
  upperParticipation = 'upperParticipation',
  issueAtDiscount = 'issueAtDiscount',
  initialLevelAsDenomination = 'initialLevelAsDenomination',
  initialCashAllocation = 'initialCashAllocation',
  initialInvestmentAllocation = 'initialInvestmentAllocation',
}

export enum ParticipationBaseBarrierEnum {
  type = 'type',
  level = 'level',
  levels = 'levels',
  obsFrequency = 'obsFrequency',
  touchAndBreak = 'touchAndBreak',
  direction = 'direction',
  investmentLevelFixingType = 'investmentLevelFixingType',
  investmentAllocation = 'investmentAllocation',
  investmentAllocations = 'investmentAllocations',
  levelsAndInvestments = 'levelsAndInvestments',
}

export enum CapitalBaseEnum {
  capitalBaseType = 'capitalBaseType',
  capitalBase = 'capitalBase',
}

export enum CouponEnum {
  frequency = 'frequency',
  couponType = 'couponType',
  conversionOnRedemption = 'conversionOnRedemption',
  schedule = 'schedule',
  fixedRate = 'fixedRate',
  fixedRateType = 'fixedRateType',
  fixedRateStep = 'fixedRateStep',
  fixedPeriods = 'fixedPeriods',
  floatingPeriods = 'floatingPeriods',
  referenceRate = 'referenceRate',
  spread = 'spread',
  cap = 'cap',
  floor = 'floor',
  dayCount = 'dayCount',
  memory = 'memory',
  multiplier = 'multiplier',
  rateReset = 'rateReset',
  rateCalculationMethod = 'rateCalculationMethod',
  rateResetLookbackShift = 'rateResetLookbackShift',
  rateObservationPeriodShift = 'rateObservationPeriodShift',
  rateObsPeriodShiftExtraCalendars = 'rateObsPeriodShiftExtraCalendars',
  rateCalculationPeriodEndType = 'rateCalculationPeriodEndType',
  rateResetSuspensionLength = 'rateResetSuspensionLength',
  suspensionLength = 'suspensionLength',
  rateInterpolation = 'rateInterpolation',
  barrier = 'barrier',
  performanceCalculation = 'performanceCalculation',
  restrike = 'restrike',
  strike = 'strike',
  leverage = 'leverage',
  digitalStrike = 'digitalStrike',
  digitalAmount = 'digitalAmount',
  rangeAccrualRate = 'rangeAccrualRate',
  couponCalculationDays = 'couponCalculationDays',
  barrierBreak = 'barrierBreak',
  conditionalCouponStrike = 'conditionalCouponStrike',
  conditionalRate = 'conditionalRate',
}

export enum CouponBarrierEnum {
  level = 'level',
  obsFrequency = 'obsFrequency',
  stepSize = 'stepSize',
  touchAndBreak = 'touchAndBreak',
  type = 'type',
  lowerLevel = 'lowerLevel',
  upperLevel = 'upperLevel',
  lowerStepSize = 'lowerStepSize',
  upperStepSize = 'upperStepSize',
}

export enum PayoffScheduleEnum {
  period = 'period',
  unadjustedPaymentDate = 'unadjustedPaymentDate',
  unadjustedObsStartDate = 'unadjustedObsStartDate',
  unadjustedObsEndDate = 'unadjustedObsEndDate',
  adjustedObsStartDate = 'adjustedObsStartDate',
  adjustedObsEndDate = 'adjustedObsEndDate',
  adjustedPaymentDate = 'adjustedPaymentDate',
  callNoticeDate = 'callNoticeDate',
  type = 'type',
  accrualPeriodStart = 'accrualPeriodStart',
  accrualPeriodEnd = 'accrualPeriodEnd',
  accrualPeriodInclusion = 'accrualPeriodInclusion',
  dayCountFraction = 'dayCountFraction',
  observations = 'observations',
  rateDeterminationDate = 'rateDeterminationDate',
  rateCalculationDates = 'rateCalculationDates',
  rateCalculationDateCounts = 'rateCalculationDateCounts',
  rateResetDatesDetail = 'rateResetDatesDetail',
  rateDeterminationDates = 'rateDeterminationDates',
  lowerLevel = 'lowerLevel',
  upperLevel = 'upperLevel',
}

export enum PayoffSchedulerEnum {
  earlyRedemptionSchedule = 'earlyRedemptionSchedule',
  couponSchedule = 'couponSchedule',
  participationSchedule = 'participationSchedule',
  upsideSchedule = 'upside',
  downsideSchedule = 'downside',
  baseSchedule = 'base',
}

export enum PayoffScheduleObservationEnum {
  assetId = 'assetId',
  unadjustedObsStartDate = 'unadjustedObsStartDate',
  unadjustedObsEndDate = 'unadjustedObsEndDate',
  adjustedObsStartDate = 'adjustedObsStartDate',
  adjustedObsEndDate = 'adjustedObsEndDate',
  barrierObsDatesInclusion = 'barrierObsDatesInclusion',
  adjustedBarrierObsDates = 'adjustedBarrierObsDates',
  adjustedBarrierFixingDates = 'adjustedBarrierFixingDates',
  unadjustedInitialFixingDates = 'unadjustedInitialFixingDates',
  adjustedInitialFixingDates = 'adjustedInitialFixingDates',
  unadjustedFinalFixingDates = 'unadjustedFinalFixingDates',
  adjustedFinalFixingDates = 'adjustedFinalFixingDates',
  barrierLevel = 'barrierLevel',
  upperLevel = 'upperLevel',
  lowerLevel = 'lowerLevel',
}

export enum PayoffEnum {
  adjustment = 'adjustment',
  coupon = 'coupon',
  callability = 'callability',
  participation = 'participation',
  capitalBase = 'capitalBase',
  investorExercise = "investorExercise",
}

export enum ScheduleType {
  ADJUSTMENT = 'adjustment',
  COUPON = 'coupon',
  CALLABILITY = 'earlyRedemption',
  INVESTOR_EXERCISE = 'investorExercise',
  PARTICIPATION = 'participation',
}

export enum FeesGroupEnum {
  feesArr = 'feesArr',
}

export enum FeesArrEnum {
  feeType = 'feeType',
  currencyFee = 'currencyFee',
  amountFee = 'amountFee',
  schedule = 'schedule',
}

export enum LegalFormEnum {
  legal = 'legal',
  productIdentifiers = 'productIdentifiers',
  countriesOfOffer = 'countriesOfOffer',
  countriesOfOfferArr = 'countriesOfOfferArr',
}

export enum CountriesOfOfferEnum {
  jurisdictionsLegal = 'jurisdictionsLegal',
  formOfOfferLegal = 'formOfOfferLegal',
  subscription = 'subscription',
  subscriptions = 'subscriptions',
}

export enum AgentsEnum {
  agentsArr = 'agentsArr',
  agents = 'agents',
  type = 'type',
}

export enum LegalEnum {
  issuerEntity = 'issuerEntity',
  issuerEntityId = 'issuerEntityId',
  legalProgramme = 'legalProgramme',
  formOfSecurities = 'formOfSecurities',
  depositTaker = 'depositTaker',
  legalFormDropdown = 'legalFormDropdown',
  formOfOfferLegal = 'formOfOfferLegal',
  listingVenue = 'listingVenue',
  eligibleLiabilityFormat = 'eligibleLiabilityFormat',
  listingStatus = 'listingStatus',
  wrapper = 'wrapper',
  issuePriceLegal = 'issuePriceLegal',
  notional = 'notional',
  numberOfUnits = 'numberOfUnits',
  minTradingAmount = 'minTradingAmountLegal',
  minTradingUnits = 'minTradingUnits',
  maxTradingAmount = 'maxTradingAmountLegal',
  maxTradingUnits = 'maxTradingUnits',
  denominationLegal = 'denominationLegal',
  tradingInUnits = 'tradingInUnits',
  incrementalTradingAmount = 'incrementalTradingAmount',
  incrementalTradingUnits = 'incrementalTradingUnits',
  maxIssueSizeNotional = 'maxIssueSizeNotional',
  maxIssueSizeUnits = 'maxIssueSizeUnits',
  governingLaws = 'governingLaws',
  securedIssuance = 'securedIssuance',
}

export enum SummaryEnum {
  performanceType = 'performanceType',
  lifecycleStatus = 'lifecycleStatus',
  productType = 'productType',
  settlementType = 'settlementType',
  rollAs = 'rollAs',
  underlyingAssets = 'underlyingAssets',
  underlyingAssetsGroup = 'underlyingAssetsGroup',
  referenceEntitiesDisplay = 'referenceEntitiesDisplay',
  keyDates = 'keyDates',
  tenor = 'tenor',
  frequency = 'frequency',
  settlementRollConvention = 'settlementRollConvention',
  tradingRollConvention = 'tradingRollConvention',
  accrualRollConvention = 'accrualRollConvention',
  tradingCalendars = 'tradingCalendars',
  settlementCalendars = 'settlementCalendars',
  productName = 'productName',
  recordStatus = 'recordStatus',
  isin = 'isin',
  currency = 'currency',
  schedule = 'schedule',
  quanto = 'quanto',
  tradeId = 'tradeId',
  tradeVersion = 'tradeVersion',
  workflowStatus = 'workflowStatus',
  StpApprovalApplicable = 'StpApprovalApplicable',
  marketingNames = 'marketingNames',
}

export enum ReferenceEntityEnum {
  performanceType = 'performanceType',
  settlementType = 'settlementType',
  referenceEntities = 'referenceEntities',
  referenceEntityId = 'referenceEntityId',
  standardReferenceObligations = 'standardReferenceObligations',
  nonStandardReferenceObligationsList = 'nonStandardReferenceObligationsList',
}

export enum ProductTypeEnum {
  AUTOCALL = 'AUTOCALL',
  AUTOCALL_GROWTH_AT_MATURITY = 'AUTOCALL_GROWTH_AT_MATURITY',
  BONUS_CERTIFICATE = 'BONUS_CERTIFICATE',
  CAPPED_FLOOR_DELTA_N = 'CAPPED_FLOOR_DELTA_N',
  DISCOUNT_CERTIFICATE = 'DISCOUNT_CERTIFICATE',
  DROPBACK_CERTIFICATE = 'DROPBACK_CERTIFICATE',
  DUAL_CURRENCY_NOTE = 'DUAL_CURRENCY_NOTE',
  EQ_ISSUER_CALLABLE = 'EQ_ISSUER_CALLABLE',
  FIXED_RATE_NOTE = 'FIXED_RATE_NOTE',
  FLOATING_RATE_NOTE = 'FLOATING_RATE_NOTE',
  PARTICIPATION_NOTE = 'PARTICIPATION_NOTE',
  PERFORMANCE_LINKED_COUPON = 'PERFORMANCE_LINKED_COUPON',
  RANGE_ACCRUAL_EQ = 'RANGE_ACCRUAL_EQ',
  RANGE_ACCRUAL_RATES = 'RANGE_ACCRUAL_RATES',
  REVERSE_CONVERTIBLE = 'REVERSE_CONVERTIBLE',
  REVERSE_CONVERTIBLE_BOND = 'REVERSE_CONVERTIBLE_BOND',
  SUPERTRACKER = 'SUPERTRACKER',
  TARGET_REDEMPTION_EQ = 'TARGET_REDEMPTION_EQ',
  CLN = 'CLN',
  FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE = 'FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE',
  PRDC = 'PRDC',
  CHOOSER = 'CHOOSER',
  RANGE_ACCRUAL = 'RANGE_ACCRUAL',
  FIXED_TO_RANGE_ACCRUAL = 'FIXED_TO_RANGE_ACCRUAL',
  FX_DIGITAL_COUPON_NOTE = 'FX_DIGITAL_COUPON_NOTE',
  WARRANT = 'WARRANT',
}

export enum KeyDatesEnum {
  issueDate = 'issueDate',
  initialSettlementDate = 'initialSettlementDate',
  redemptionDate = 'redemptionDate',
  initialFixingDate = 'initialFixingDate', //
  finalFixingDate = 'finalFixingDate', //
  subStartDate = 'subStartDate',
  subEndDate = 'subEndDate',
  isaSubsEndDate = 'isaSubsEndDate',
  initialObservationDate = 'initialObservationDate',
  finalObservationDate = 'finalObservationDate',
  tradeDate = 'tradeDate',
  barrierObsStartDate = 'barrierObsStartDate',
  barrierObsEndDate = 'barrierObsEndDate',
  productFinalisationDate = 'productFinalisationDate',
  tradingRollConvention = 'tradingRollConvention',
  settlementRollConvention = 'settlementRollConvention',
  interestStartDate = 'interestStartDate',
  interestEndDate = 'interestEndDate',
  accrualRollConvention = 'accrualRollConvention',
  listingStartDate = 'listingStartDate',
  listingEndDate = 'listingEndDate',
  exerciseStartDate = 'exerciseStartDate',
}

export enum KeyDatesBackendEnum {
  issueDate = 'issueDate',
  initialSettlementDate = 'initialSettlementDate',
  maturityDate = 'maturityDate',
  initialFixingDate = 'initialFixingDate',
  finalFixingDate = 'finalFixingDate',
  sales_SubscriptionStartDate = 'sales_SubscriptionStartDate',
  sales_SubscriptionEndDate = 'sales_SubscriptionEndDate',
  sales_SubscriptionISAEndDate = 'sales_SubscriptionISAEndDate',
  tradeDate = 'tradeDate',
  dtePmtUnadjFirstT = 'dtePmtUnadjFirstT',
  dtePmtUnadjLast0 = 'dtePmtUnadjLast0',
  productFinalisationDate = 'productFinalisationDate',
  interestStartDate = 'interestStartDate',
  interestEndDate = 'interestEndDate',
  barrierObsStartDate = 'barrierObsStartDate',
  barrierObsEndDate = 'barrierObsEndDate',
  listingStartDate = 'listingStartDate',
  listingEndDate = 'listingEndDate',
  exerciseStartDate = 'exerciseStartDate',
}

export enum FrequencyType {
  TENOR = 'TENOR',
}

export enum CreditProvisionEnum {
  physicalSettlementMatrix = 'physicalSettlementMatrix',
  creditPeriodEndDate = 'creditPeriodEndDate',
  lossAtMaturity = 'lossAtMaturity',
  dcDeterminations = 'dcDeterminations',
  excludedObligations = 'excludedObligations',
  excludedObligationsList = 'excludedObligationsList',
  obligationSpecifiedCurrency = 'obligationSpecifiedCurrency',
  obligationDomesticCurrency = 'obligationDomesticCurrency',
  allGuarantees = 'allGuarantees',
  creditEvents = 'creditEvents',
  creditEventGracePeriod = 'creditEventGracePeriod',
  escrow = 'escrow',
  noticeOfPubliclyAvailableInformation = 'noticeOfPubliclyAvailableInformation',
  fixedRecoveryAmount = 'fixedRecoveryAmount',

  financialReferenceEntityTerms = 'financialReferenceEntityTerms',
  subordinatedEuropeanInsuranceTerms = 'subordinatedEuropeanInsuranceTerms',
  passThroughSecurities = 'passThroughSecurities',
  ntceSupplement = 'ntceSupplement',
  suppUSMunicipals = 'suppUSMunicipals',
  supp2014SovereignNoAssetPkgDelivery = 'supp2014SovereignNoAssetPkgDelivery',

  fxPriceSource = 'fxPriceSource',
  fixingRateTime = 'fixingRateTime',
  additionalCreditBusinessCentre = 'additionalCreditBusinessCentre',
  additionalCreditBusinessCentreDetails = 'additionalCreditBusinessCentreDetails',
  cashSettlementQuotationMethod = 'cashSettlementQuotationMethod',
  creditEventAccruedCouponSecurities = 'creditEventAccruedCouponSecurities',
  creditContingentCallOptionSecurities = 'creditContingentCallOptionSecurities',
  maturityCapitalProtectedSecurities = 'maturityCapitalProtectedSecurities',
  underlyingLinkedRedemptionSecurities = 'underlyingLinkedRedemptionSecurities',
  detailsRelatingToInstalmentNotes = 'detailsRelatingToInstalmentNotes',
  provisionsMonolineInsurer = 'provisionsMonolineInsurer',
  provisionsForLPN = 'provisionsForLPN',
  provisionsForRepublicOfHungary = 'provisionsForRepublicOfHungary',
  supplementTo2014ISDACDD = 'supplementTo2014ISDACDD',
  provisionsForRussianFederation = 'provisionsForRussianFederation',
  provisionsForArgentineRepublic = 'provisionsForArgentineRepublic',
  addnProvisionsCertainRussianEntities = 'addnProvisionsCertainRussianEntities',
  addnProvisionsCertainVenezuelanEntities = 'addnProvisionsCertainVenezuelanEntities',
  addnProvisionsHellenicRepublic = 'addnProvisionsHellenicRepublic',
  seniorNonPreferredRefObligations = 'seniorNonPreferredRefObligations',

  provisionsForSukukCorporate = 'provisionsForSukukCorporate',
  kidWithdrawalRightsDisclosure = 'kidWithdrawalRightsDisclosure',
  settlementMethod = 'settlementMethod',
  fallbackSettlementMethod = 'fallbackSettlementMethod',
  settlementProvisions = 'settlementProvisions',
  cashSettlementValuationMethod = 'cashSettlementValuationMethod',
  accruedInterest = 'accruedInterest',
  extensionPeriodInterest = 'extensionPeriodInterest',
  unwindCosts = 'unwindCosts',
}

export enum ProductNotesEnum {
  notes = 'notes',
  tasks = 'tasks',
}

export enum RangeAccrualEnum {
  couponType = 'couponType',
}

export enum PricingEnum {
  PRICING = 'pricing',
  FAIR_VALUE = 'pricingFairValue',
  ECONOMIC_VALUE = 'pricingEconomicValue',
  REOFFER_PRICE = 'pricingReofferPrice',
  ISSUER_ESTIMATE_VALUE = 'pricingIssuerEstimateValue',
  FUNDING_CURVE = 'pricingFundingCurve',
  FUNDED_BY = 'pricingFundedBy',
  BID_OFFER_SPREAD = 'pricingBidOfferSpread',
}

export enum SalesEnum {
  targetMarket = 'targetMarket',
  summaryRiskIndicator = 'summaryRiskIndicator',
  targetMarkets = 'targetMarkets',
  feesGroup = 'feesGroup',
  esgThematics = 'esgThematics',
  salesRegion = 'salesRegion',
  contactInformation = 'contactInformation',
  salesSecondaryMktRequired = 'salesSecondaryMktRequired',
  salesSecondaryMktQuotationType = 'secondaryMktQuotationType',
  salesTelekursSetUp = 'salesTelekursSetUp',
  secondaryMarketAndDataPublising = 'secondaryMarketAndDataPublising',
}
